import type { FaireProductEntity } from "../../entity_types/product";

export const p_8z39ej2srs: FaireProductEntity = {
  token: "p_8z39ej2srs",
  type: "product",
  name: "Deity Carved Wooden Strikers-Buddha",
  brandToken: "b_v58tcqg42w",
  brandName: "Now N Zen",
  imageUrl:
    "https://cdn.faire.com/fastly/9c050063b2207330b7234dd20141b706fcc64b3556466897a689f3d5d0db2a54.png",
  galleryImageUrls: [],
  priceDollars: 10.39,
  description:
    "These strikers are carved to resemble a few different Deities and/or symbols. Currently, we have three different designs, this one is Buddha.\n1” x 7” in dimension.",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:56.024Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
